export default "__VITE_ASSET__23c3d1cf__"